"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[37544],{

/***/ 837544:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "ProductVariants": function() { return /* binding */ ProductVariants; }
});

// EXTERNAL MODULE: ../../.yarn/cache/react-npm-18.2.0-1eae08fee2-88e38092da.zip/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(561261);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-dc53b6832e/1/packages/ds-foundation/dist/components/Typography/index.es.js + 1 modules
var index_es = __webpack_require__(621655);
// EXTERNAL MODULE: ./contexts/ProductDetailContext.tsx + 3 modules
var ProductDetailContext = __webpack_require__(534924);
// EXTERNAL MODULE: ./contexts/GlobalDataContext.tsx
var GlobalDataContext = __webpack_require__(684443);
// EXTERNAL MODULE: ../../.yarn/cache/react-npm-18.2.0-1eae08fee2-88e38092da.zip/node_modules/react/index.js
var react = __webpack_require__(891987);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-dc53b6832e/1/packages/ds-foundation/dist/components/Shape/index.es.js
var Shape_index_es = __webpack_require__(425336);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-dc53b6832e/1/packages/ds-foundation/dist/components/Flex/Flex.es.js
var Flex_es = __webpack_require__(387100);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@emotion-styled-virtual-a36c90119c/0/cache/@emotion-styled-npm-11.3.0-a31c55914d-5e5c1e89d2.zip/node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 1 modules
var emotion_styled_browser_esm = __webpack_require__(212951);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-teko-ecommerce-virtual-ca6c4b0024/1/packages/teko-ecommerce/dist/components/TekoLink/TekoLink.es.js
var TekoLink_es = __webpack_require__(675601);
;// CONCATENATED MODULE: ./modules/product-detail/shared/ProductVariantItem.tsx




const ProductVariantItem = (param)=>{
    let { variant , onSelect , visible =true  } = param;
    var ref;
    if (!((ref = variant.options) === null || ref === void 0 ? void 0 : ref.length)) return null;
    const selectedOption = variant.options.find((e)=>e.selected);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Shape_index_es/* Shape */.b, {
        marginTop: "s8",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Caption */.YS, {
                level: 2,
                color: "textSecondary",
                style: {
                    textTransform: "uppercase"
                },
                children: "".concat(variant.title).concat(selectedOption ? ": ".concat(selectedOption.label) : "")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex_es/* Flex */.k, {
                marginTop: "s8",
                flexWrap: "wrap",
                maxWidth: "calc(100% - 64px)",
                children: variant.options.map((option, index)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(WrapperOption, {
                        href: "/".concat(option.url),
                        onClick: (e)=>{
                            e.preventDefault();
                            onSelect(option);
                        },
                        isActive: option.selected,
                        isVisible: visible,
                        borderRadius: "s",
                        margin: [
                            "s0",
                            "s8",
                            "s8",
                            "s0"
                        ],
                        padding: [
                            "s8",
                            "s16"
                        ],
                        blur: option.quantity === 0,
                        className: "att-variant-".concat(option.label, "-sku-").concat(option.sku),
                        children: option.label
                    }, index))
            })
        ]
    });
};
const WrapperOption = (0,emotion_styled_browser_esm["default"])(TekoLink_es/* TekoLink */.A)((param)=>{
    let { isActive , theme , isVisible , blur  } = param;
    return "\n    border: 1px ".concat(isActive ? theme.colors.primary500 : "#e0e0e0", " solid;\n    position: relative;\n    color: ").concat(isActive ? theme.colors.primary500 : "black", ";\n    background-color: ").concat(isVisible || isActive === true ? "#fff" : "#e0e0e0", ";\n    text-transform: capitalize;\n    text-align: center;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    cursor: ").concat(isVisible || isActive === true ? "pointer" : "not-allowed", ";\n    opacity: ").concat(blur ? "0.5" : "1", "\n");
});

;// CONCATENATED MODULE: ./modules/product-detail/shared/ProductVariants.tsx





const ProductVariants = ()=>{
    const { product , onSelectVariant  } = (0,ProductDetailContext/* useProductDetailState */.W)();
    const { productOptions , clearanceTypeDescription , sku  } = product || {};
    const { fixedVariants  } = (0,GlobalDataContext/* useTenantConfig */.Wx)();
    // UX4BUYER-6250: hardcode variants for phongvu
    const variants = (0,react.useMemo)(()=>{
        const orgVariants = productOptions === null || productOptions === void 0 ? void 0 : productOptions.rows;
        if (!orgVariants) return;
        if (!fixedVariants || !sku) return orgVariants;
        const fixedVariant = fixedVariants[sku];
        if (!fixedVariant) return orgVariants;
        return orgVariants.map((variant)=>{
            const fixedVariantOptions = fixedVariant[variant.title];
            if (fixedVariantOptions) {
                const options = fixedVariantOptions.map((opt)=>{
                    const existingOption = variant.options.find((option)=>option.label === opt.label);
                    return {
                        label: opt.label,
                        url: opt.url,
                        sku: opt.sku,
                        quantity: 1,
                        selected: !!existingOption
                    };
                });
                return {
                    title: variant.title,
                    options
                };
            } else {
                return variant;
            }
        });
    }, [
        fixedVariants,
        productOptions === null || productOptions === void 0 ? void 0 : productOptions.rows,
        sku
    ]);
    if (!(productOptions === null || productOptions === void 0 ? void 0 : productOptions.rows.length)) return null;
    return variants ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            variants.map((variant, index)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(ProductVariantItem, {
                    variant: variant,
                    onSelect: onSelectVariant
                }, index)),
            !!clearanceTypeDescription && /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Caption */.YS, {
                level: 1,
                color: "textSecondary",
                children: clearanceTypeDescription
            })
        ]
    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(react.Fragment, {});
};


/***/ })

}]);